var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrScanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.7 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f9f9;}.cls-2{fill:#e9eef7;}.cls-3,.cls-4{fill:#fff;}.cls-5{fill:#5887c8;}.cls-4{font-family:Montserrat-Bold, Montserrat;font-size:6.24px;font-weight:700;letter-spacing:.1em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.9,
    y: 134.61,
    width: 193.66,
    height: 193.66
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "168.28 146.09 159.3 146.09 159.3 155.06 168.28 155.06 177.26 155.06 177.26 146.09 168.28 146.09"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 146.09,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.19 155.06 195.22 155.06 195.22 146.09 186.24 146.09 186.24 155.06 177.26 155.06 177.26 164.04 177.26 173.02 168.28 173.02 168.28 182 177.26 182 177.26 190.98 186.24 190.98 195.22 190.98 195.22 182 186.24 182 186.24 173.02 186.24 164.04 195.22 164.04 204.19 164.04 213.17 164.04 213.17 155.06 204.19 155.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.15 173.02 222.15 164.04 213.17 164.04 213.17 173.02 213.17 182 222.15 182 222.15 173.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.3 190.98 159.3 199.96 168.28 199.96 168.28 190.98 168.28 182 159.3 182 159.3 190.98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.19,
    y: 182,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.28,
    y: 244.85,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.43,
    y: 199.96,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.19 208.94 213.17 208.94 213.17 217.91 222.15 217.91 222.15 208.94 231.13 208.94 231.13 199.96 222.15 199.96 222.15 190.98 213.17 190.98 213.17 199.96 204.19 199.96 195.22 199.96 186.24 199.96 177.26 199.96 177.26 208.94 186.24 208.94 195.22 208.94 195.22 217.91 204.19 217.91 204.19 208.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.04 208.94 267.04 199.96 258.07 199.96 258.07 208.94 258.07 217.91 267.04 217.91 267.04 208.94"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.43,
    y: 217.91,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.32 226.89 159.3 226.89 159.3 217.91 168.28 217.91 168.28 208.94 159.3 208.94 150.32 208.94 150.32 199.96 141.34 199.96 141.34 208.94 141.34 217.91 150.32 217.91 150.32 226.89"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.24,
    y: 217.91,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.09 217.91 249.09 208.94 249.09 199.96 240.11 199.96 240.11 208.94 240.11 217.91 231.13 217.91 222.15 217.91 222.15 226.89 231.13 226.89 240.11 226.89 240.11 235.87 249.09 235.87 249.09 226.89 258.07 226.89 258.07 217.91 249.09 217.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.32 226.89 141.34 226.89 141.34 217.91 132.36 217.91 132.36 208.94 132.36 199.96 123.39 199.96 123.39 208.94 114.41 208.94 114.41 217.91 123.39 217.91 123.39 226.89 132.36 226.89 132.36 235.87 141.34 235.87 141.34 244.85 150.32 244.85 150.32 235.87 150.32 226.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.28 235.87 177.26 235.87 177.26 244.85 186.24 244.85 186.24 235.87 186.24 226.89 177.26 226.89 177.26 217.91 168.28 217.91 168.28 226.89 168.28 235.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.04 226.89 258.07 226.89 258.07 235.87 258.07 244.85 249.09 244.85 249.09 253.83 258.07 253.83 258.07 262.81 267.04 262.81 267.04 271.79 267.04 280.77 276.02 280.77 276.02 271.79 276.02 262.81 276.02 253.83 267.04 253.83 267.04 244.85 276.02 244.85 276.02 235.87 267.04 235.87 267.04 226.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.41 235.87 105.43 235.87 105.43 244.85 105.43 253.83 114.41 253.83 114.41 262.81 123.39 262.81 123.39 253.83 123.39 244.85 114.41 244.85 114.41 235.87"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.39,
    y: 235.87,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.15 235.87 222.15 226.89 213.17 226.89 204.19 226.89 195.22 226.89 195.22 235.87 195.22 244.85 204.19 244.85 204.19 235.87 213.17 235.87 213.17 244.85 222.15 244.85 222.15 253.83 231.13 253.83 231.13 244.85 240.11 244.85 240.11 235.87 231.13 235.87 222.15 235.87"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.36,
    y: 244.85,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.3 244.85 150.32 244.85 150.32 253.83 150.32 262.81 159.3 262.81 159.3 271.79 159.3 280.77 168.28 280.77 168.28 271.79 168.28 262.81 168.28 253.83 159.3 253.83 159.3 244.85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.24,
    y: 244.85,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.26,
    y: 253.83,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.17 271.79 213.17 262.81 213.17 253.83 204.19 253.83 204.19 262.81 195.22 262.81 195.22 271.79 204.19 271.79 213.17 271.79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.26,
    y: 271.79,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.22,
    y: 280.77,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,280.77v-26.95h-36.09v36.09h8.99v8.81h8.98v-8.81h8.98v8.81h8.98v-8.81h.17v-.17h8.81v8.98h17.96v-8.98h-8.98v-8.98h-17.79Zm-29.18-20.03h22.45v22.45h-22.45v-22.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.28 298.72 168.28 307.7 177.26 307.7 177.26 298.72 177.26 289.74 177.26 280.77 168.28 280.77 168.28 289.74 168.28 298.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.19 298.72 204.19 307.7 213.17 307.7 222.15 307.7 222.15 298.72 213.17 298.72 204.19 298.72"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.3,
    y: 307.7,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.24 316.68 195.22 316.68 195.22 307.7 186.24 307.7 177.26 307.7 177.26 316.68 186.24 316.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.07 307.7 258.07 316.68 267.04 316.68 276.02 316.68 276.02 307.7 267.04 307.7 258.07 307.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.81,
    y: 267.47,
    width: 8.98,
    height: 8.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.32,146.09h-44.89v44.89h44.89v-44.89Zm-6.73,38.16h-31.43v-31.43h31.43v31.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.9,
    y: 159.55,
    width: 17.96,
    height: 17.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.13,146.09v44.89h44.89v-44.89h-44.89Zm38.16,38.16h-31.43v-31.43h31.43v31.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.6,
    y: 159.55,
    width: 17.96,
    height: 17.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.43,316.79h44.89v-44.89h-44.89v44.89Zm6.73-38.16h31.43v31.43h-31.43v-31.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.9,
    y: 285.37,
    width: 17.96,
    height: 17.96
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 247.73,
    y: 75.01,
    width: 161.51,
    height: 324.31,
    rx: 15.22,
    ry: 15.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.4,
    y: 129.22,
    width: 144.16,
    height: 144.35,
    rx: 9.78,
    ry: 9.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.94,402.34h-130.92c-10.1,0-18.31-8.21-18.31-18.31V90.31c0-10.1,8.21-18.31,18.31-18.31h130.92c10.1,0,18.31,8.21,18.31,18.31V384.03c0,10.1-8.21,18.31-18.31,18.31ZM263.02,78.03c-6.77,0-12.28,5.51-12.28,12.28V384.03c0,6.77,5.51,12.28,12.28,12.28h130.92c6.77,0,12.28-5.51,12.28-12.28V90.31c0-6.77-5.51-12.28-12.28-12.28h-130.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(264.28 85.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9:21")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 367.31,
    y: 82.64,
    width: 1,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 368.65,
    y: 81.56,
    width: 1,
    height: 3.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 369.99,
    y: 80.84,
    width: 1,
    height: 4.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.57,84.36l.58,.58c.51-.45,1.28-.44,1.77,.04l.58-.58c-.81-.8-2.11-.81-2.93-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.6,83.39l.58,.58c1.05-.99,2.69-.98,3.72,.04l.58-.58c-1.35-1.34-3.52-1.35-4.88-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.69,82.48l.58,.58c1.55-1.49,4-1.47,5.53,.04l.58-.58c-1.85-1.84-4.83-1.85-6.7-.04Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "395.37 82.12 394.19 82.12 394.19 81.13 387.66 81.13 387.66 85.28 394.19 85.28 394.19 84.29 395.37 84.29 395.37 82.12"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "285.82 136.96 285.82 140.01 267.33 140.01 267.33 158.48 264.28 158.48 264.28 136.96 285.82 136.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "371.15 265.46 371.15 262.4 389.63 262.4 389.63 243.93 392.68 243.93 392.68 265.46 371.15 265.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "392.73 158.54 389.68 158.54 389.68 140.06 371.21 140.06 371.21 137.01 392.73 137.01 392.73 158.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.23 243.87 267.28 243.87 267.28 262.35 285.76 262.35 285.76 265.41 264.23 265.41 264.23 243.87"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 279.14,
    y: 151.13,
    width: 98.69,
    height: 98.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "317.04 156.98 312.47 156.98 312.47 161.56 317.04 161.56 321.62 161.56 321.62 156.98 317.04 156.98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.92,
    y: 156.98,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.35 161.56 330.77 161.56 330.77 156.98 326.19 156.98 326.19 161.56 321.62 161.56 321.62 166.13 321.62 170.71 317.04 170.71 317.04 175.28 321.62 175.28 321.62 179.86 326.19 179.86 330.77 179.86 330.77 175.28 326.19 175.28 326.19 170.71 326.19 166.13 330.77 166.13 335.35 166.13 339.92 166.13 339.92 161.56 335.35 161.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.5 170.71 344.5 166.13 339.92 166.13 339.92 170.71 339.92 175.28 344.5 175.28 344.5 170.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.47 179.86 312.47 184.44 317.04 184.44 317.04 179.86 317.04 175.28 312.47 175.28 312.47 179.86"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.35,
    y: 175.28,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.04,
    y: 207.31,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.01,
    y: 184.44,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.35 189.01 339.92 189.01 339.92 193.59 344.5 193.59 344.5 189.01 349.07 189.01 349.07 184.44 344.5 184.44 344.5 179.86 339.92 179.86 339.92 184.44 335.35 184.44 330.77 184.44 326.19 184.44 321.62 184.44 321.62 189.01 326.19 189.01 330.77 189.01 330.77 193.59 335.35 193.59 335.35 189.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.38 189.01 367.38 184.44 362.8 184.44 362.8 189.01 362.8 193.59 367.38 193.59 367.38 189.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.01,
    y: 193.59,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.89 198.16 312.47 198.16 312.47 193.59 317.04 193.59 317.04 189.01 312.47 189.01 307.89 189.01 307.89 184.44 303.32 184.44 303.32 189.01 303.32 193.59 307.89 193.59 307.89 198.16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.19,
    y: 193.59,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.22 193.59 358.22 189.01 358.22 184.44 353.65 184.44 353.65 189.01 353.65 193.59 349.07 193.59 344.5 193.59 344.5 198.16 349.07 198.16 353.65 198.16 353.65 202.74 358.22 202.74 358.22 198.16 362.8 198.16 362.8 193.59 358.22 193.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.89 198.16 303.32 198.16 303.32 193.59 298.74 193.59 298.74 189.01 298.74 184.44 294.16 184.44 294.16 189.01 289.59 189.01 289.59 193.59 294.16 193.59 294.16 198.16 298.74 198.16 298.74 202.74 303.32 202.74 303.32 207.31 307.89 207.31 307.89 202.74 307.89 198.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.04 202.74 321.62 202.74 321.62 207.31 326.19 207.31 326.19 202.74 326.19 198.16 321.62 198.16 321.62 193.59 317.04 193.59 317.04 198.16 317.04 202.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.38 198.16 362.8 198.16 362.8 202.74 362.8 207.31 358.22 207.31 358.22 211.89 362.8 211.89 362.8 216.47 367.38 216.47 367.38 221.04 367.38 225.62 371.95 225.62 371.95 221.04 371.95 216.47 371.95 211.89 367.38 211.89 367.38 207.31 371.95 207.31 371.95 202.74 367.38 202.74 367.38 198.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.59 202.74 285.01 202.74 285.01 207.31 285.01 211.89 289.59 211.89 289.59 216.47 294.16 216.47 294.16 211.89 294.16 207.31 289.59 207.31 289.59 202.74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.16,
    y: 202.74,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.5 202.74 344.5 198.16 339.92 198.16 335.35 198.16 330.77 198.16 330.77 202.74 330.77 207.31 335.35 207.31 335.35 202.74 339.92 202.74 339.92 207.31 344.5 207.31 344.5 211.89 349.07 211.89 349.07 207.31 353.65 207.31 353.65 202.74 349.07 202.74 344.5 202.74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.74,
    y: 207.31,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.47 207.31 307.89 207.31 307.89 211.89 307.89 216.47 312.47 216.47 312.47 221.04 312.47 225.62 317.04 225.62 317.04 221.04 317.04 216.47 317.04 211.89 312.47 211.89 312.47 207.31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.19,
    y: 207.31,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.62,
    y: 211.89,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.92 221.04 339.92 216.47 339.92 211.89 335.35 211.89 335.35 216.47 330.77 216.47 330.77 221.04 335.35 221.04 339.92 221.04"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.62,
    y: 221.04,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.77,
    y: 225.62,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,225.62v-13.73h-18.39v18.39h4.58v4.49h4.58v-4.49h4.58v4.49h4.58v-4.49h.09v-.09h4.49v4.58h9.15v-4.58h-4.58v-4.58h-9.07Zm-14.87-10.21h11.44v11.44h-11.44v-11.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.04 234.77 317.04 239.34 321.62 239.34 321.62 234.77 321.62 230.19 321.62 225.62 317.04 225.62 317.04 230.19 317.04 234.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.35 234.77 335.35 239.34 339.92 239.34 344.5 239.34 344.5 234.77 339.92 234.77 335.35 234.77"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 239.34,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.19 243.92 330.77 243.92 330.77 239.34 326.19 239.34 321.62 239.34 321.62 243.92 326.19 243.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.8 239.34 362.8 243.92 367.38 243.92 371.95 243.92 371.95 239.34 367.38 239.34 362.8 239.34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.87,
    y: 218.84,
    width: 4.58,
    height: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,156.98h-22.88v22.88h22.88v-22.88Zm-3.43,19.45h-16.02v-16.01h16.02v16.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.88,
    y: 163.85,
    width: 9.15,
    height: 9.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.07,156.98v22.88h22.88v-22.88h-22.88Zm19.45,19.45h-16.02v-16.01h16.02v16.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.94,
    y: 163.85,
    width: 9.15,
    height: 9.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.01,243.98h22.88v-22.88h-22.88v22.88Zm3.43-19.45h16.02v16.02h-16.02v-16.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.88,
    y: 227.96,
    width: 9.15,
    height: 9.15
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScanner);
export default __webpack_public_path__ + "static/media/qrScanner.0934c836cb7355663b06adf7b7eb8708.svg";
export { ForwardRef as ReactComponent };